export default {"src":"https://s.sylndr.com/c-0ea2b57/_next/static/media/mechanicalFaulty.a56dcc70.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};